export const alertsTestIDs = {
  exit: {
    headlineText: 'alerts_exit_heading_text',
    buttonNo: 'alerts_exit_button_no',
    buttonYes: 'alerts_exit_button_yes',
  },
  overlay: {
    headlineText: 'alerts_overlay_heading_text',
    subText: 'alerts_overlay_sub_text',
    viewRadarButton: 'alerts_overlay_button_viewradar',
    dismissButton: 'alerts_overlay_button_dismiss',
  },
  location: {
    headlineText: 'alerts_location_heading_text',
    helpText: 'alerts_location_help_text',
    locationText: 'alerts_location_location_text',
    itsCorrectButton: 'alerts_location_button_itscorrect',
    changeLocationButton: 'alerts_location_button_changelocation',
  },
  disconnected: {
    headlineText: 'alerts_disconnected_heading_text',
    detailText: 'alerts_disconnected_detail_text',
    okButton: 'alerts_disconnected_ok_button',
  },
  pdpDescription: {
    showTitle: 'alerts_pdp_title',
    description: 'alerts_pdp_description',
    focusHandle: 'alerts_pdp_handle',
    scrollView: 'alerts_pdp_scrollview',
  },
  liveANF: {
    liveTitle: 'alerts_liveANF_title',
    optInTitle: 'alerts_liveANF_title',
    watchNowButton: 'alerts_liveANF_watch_button',
    cancelButton: 'alerts_liveANF_cancel_button',
    gotItButton: 'alerts_liveANF_gotIt_button',
  },
};

export const AlertModalTypes = {
  exit: 'alertExit',
  overlay: 'alertOverlay',
  location: 'alertLocation',
  disconnected: 'alertDisconnected',
  showDescription: 'alertShowDescription',
  liveANF: 'alertLiveANF',
};
